import { IsInt } from 'class-validator';

export class ProfileDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<ProfileDeleteRequest>) {
        this.id = data && data.id;
    }
}
